// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"ce911c79","166":"ce4344c6","525":"a135e4ed","779":"60326e02","876":"3059a7b1","896":"0881b1dd"}[chunkId] + ".css";
};